(() => {
  if(window.vrUnifiedGalleryLoaded)return;
  window.vrUnifiedGalleryLoaded=true;
  const canHover=event=>event.pointerType==='mouse'&&matchMedia('(hover: hover)').matches;
  const read=el=>{try{return JSON.parse(el.querySelector('[data-vr-gallery-data]')?.textContent||'null');}catch{return null;}};
  const matchesColor=(a,data,color)=>{
    if(!data.colorPosition)return true;
    if(data.productId==='8064221774100')return color==='18k White Gold';
    if(a.colors?.length)return a.colors.includes(color);
    const colors=[...new Set(data.variants.map(v=>v.color))];
    if(colors.length===1)return true;
    return Boolean(a.alt && a.alt.toLowerCase().includes(color.toLowerCase()));
  };
  const imagesFor=(data,color)=>[...(data.studio?[data.studio]:[]),...data.media].filter(a=>a.type==='image'&&matchesColor(a,data,color));
  const hoverFor=(data,color)=>{
    const images=imagesFor(data,color);
    return images.find(a=>a.id===data.wornId)||images[1]||images[0];
  };
  function wireCard(card){
    if(card.dataset.vrHoverCard)return;
    const data=read(card),img=card.querySelector('.card__media img')||card.querySelector('a img');
    if(!data||!img)return;
    card.dataset.vrHoverCard='true';let saved=null;
    const restore=()=>{if(!saved)return;for(const [key,value] of Object.entries(saved)){if(value===null)img.removeAttribute(key);else img.setAttribute(key,value);}saved=null;};
    card.addEventListener('pointerenter',event=>{
      if(!canHover(event))return;const next=hoverFor(data,data.selectedColor);if(!next)return;
      saved=Object.fromEntries(['src','srcset','sizes','alt'].map(key=>[key,img.getAttribute(key)]));
      img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=next.src;
    });
    card.addEventListener('pointerleave',restore);card.addEventListener('pointercancel',restore);
  }
  async function wireGallery(gallery){
    if(gallery.dataset.vrUnified)return;
    const data=read(gallery);if(!data)return;
    gallery.dataset.vrUnified='true';
    await customElements.whenDefined('media-gallery');
    if(!gallery.isConnected)return;
    const product=gallery.closest('.product'),info=product?.querySelector('.product__info-container');
    if(!product||!info)return;
    product.classList.add('vr-unified-product');
    const heading=document.createElement('header');heading.className='vr-unified-heading';
    const title=info.querySelector('.product__title');if(title){const vendor=title.previousElementSibling;if(vendor?.matches('.product__text'))heading.append(vendor);heading.append(title);}
    const sku=document.createElement('p');sku.className='vr-product-sku';heading.append(sku);product.prepend(heading);
    const empty=document.createElement('p');empty.className='vr-gallery-empty';empty.textContent=data.labels.empty;empty.hidden=true;gallery.prepend(empty);
    const viewer=gallery.querySelector('[id^=GalleryViewer]'),thumbs=gallery.querySelector('[id^=GalleryThumbnails]');
    const prefix=gallery.id.replace('MediaGallery-','')+'-';
    const getId=el=>el.dataset.mediaId?.slice(prefix.length);
    let color=data.selectedColor,active=null;
    const restoreHover=()=>viewer.querySelectorAll('.vr-hover-layer').forEach(el=>el.remove());
    const setActive=(fullId)=>{
      restoreHover();
      const slides=[...viewer.querySelectorAll('li[data-media-id]')];
      const next=slides.find(el=>el.dataset.mediaId===fullId&&!el.hidden)||slides.find(el=>!el.hidden);
      if(!next)return;active=next.dataset.mediaId;
      slides.forEach(el=>{el.classList.toggle('is-active',el===next);if(el!==next)el.querySelectorAll('video').forEach(v=>v.pause());});
      thumbs?.querySelectorAll('[data-target]').forEach(el=>{const b=el.querySelector('button');if(b)b.setAttribute('aria-current',String(el.dataset.target===active));});
      viewer.querySelector('ul')?.scrollTo({left:0});
    };
    gallery.setActiveMedia=setActive;
    gallery.onSlideChanged=()=>{};
    gallery.addEventListener('click',event=>{
      const thumb=event.target.closest('[data-target]');if(!thumb||!thumbs?.contains(thumb))return;
      event.preventDefault();event.stopImmediatePropagation();setActive(thumb.dataset.target);
    },true);
    const applyVariant=variant=>{
      restoreHover();color=variant?.color??color;
      sku.textContent=variant?.sku?'Style '+variant.sku:'';sku.hidden=!variant?.sku;
      const allowed=new Set([...(data.studio?[data.studio]:[]),...data.media].filter(a=>matchesColor(a,data,color)).map(a=>prefix+a.id));
      viewer.querySelectorAll('li[data-media-id]').forEach(el=>{el.hidden=!allowed.has(el.dataset.mediaId);if(el.hidden)el.classList.remove('is-active');});
      thumbs?.querySelectorAll('[data-target]').forEach(el=>el.hidden=!allowed.has(el.dataset.target));
      const first=viewer.querySelector('li[data-media-id]:not([hidden])');empty.hidden=Boolean(first);viewer.hidden=!first;if(thumbs)thumbs.hidden=!first;
      gallery.classList.toggle('vr-no-color-images',!first);
      if(first)setActive(first.dataset.mediaId);
    };
    applyVariant(data.variants.find(v=>v.id===data.selectedVariant));
    viewer.addEventListener('pointerenter',event=>{
      if(!canHover(event))return;
      const next=hoverFor(data,color),slide=viewer.querySelector('.is-active');
      const box=slide?.querySelector('.product__modal-opener--image');
      if(!box||!next||getId(slide)===next.id)return;
      const layer=document.createElement('img');layer.className='vr-hover-layer';layer.alt='';layer.setAttribute('aria-hidden','true');layer.src=next.src;box.append(layer);
    });
    viewer.addEventListener('pointerleave',restoreHover);viewer.addEventListener('pointercancel',restoreHover);
    if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.variantChange,event=>{
      if(event.data.sectionId!==gallery.id.replace('MediaGallery-',''))return;
      applyVariant(data.variants.find(v=>v.id===String(event.data.variant?.id)));
    });
  }
  const scan=()=>{document.querySelectorAll('media-gallery').forEach(wireGallery);document.querySelectorAll('.vrm-card,.card-wrapper').forEach(wireCard);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
  new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('media-gallery,.card-wrapper')||n.querySelector?.('media-gallery,.card-wrapper')))))scan();}).observe(document.documentElement,{childList:true,subtree:true});
})();
